import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputField from 'shared-components/FormFields/Input';
import PasswordStrengthMeter from 'shared-components/FormFields/PasswordStrengthMeter';

const delegateEventHandler = (eventName, component) => {
  return (e) => {
    const val = e.target.value;
    if (component.props[eventName]) component.props[eventName](e, val);
  };
};

class PasswordWithMeter extends Component {
  onBlur = delegateEventHandler('onBlur', this);
  onChange = delegateEventHandler('onChange', this);
  onFocus = delegateEventHandler('onFocus', this);
  onInput = delegateEventHandler('onInput', this);
  onKeyDown = delegateEventHandler('onKeyDown', this);

  render() {
    const inputProps = {
      ...this.props,
      type: 'password',
      onBlur: this.onBlur,
      onChange: this.onChange,
      onFocus: this.onFocus,
      onInput: this.onInput,
      onKeyDown: this.onKeyDown,
    };
    delete inputProps.passwordScore;

    const passwordMeterProps = {
      passwordScore: this.props.passwordScore,
      inputValid: inputProps.valid,
    }

    return (
      <div>
        <InputField {...inputProps} />
        <PasswordStrengthMeter {...passwordMeterProps} />
      </div>
    );
  }
}

PasswordWithMeter.propTypes = {
  className: PropTypes.string,
  error: PropTypes.string,
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
  }).isRequired,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onInput: PropTypes.func,
  onKeyDown: PropTypes.func,
  passwordScore: PropTypes.number,
  tooltip: PropTypes.object,
  type: PropTypes.string.isRequired,
  valid: PropTypes.bool,
};

export default PasswordWithMeter;
